import { BaseApiService } from "../base/base-api.service";

import { TnAClockingSTO } from "../../models/tna";

import { toastifyResponse } from "../../utils/toastify-response/toastify-response";
import { TnADataDTO } from "../../models/tna/tna-data/tna-data-dto";
import { TnADataFilter } from "../../models/tna/tna-data/tna-data-filter";
import { TnACounterDTO } from "../../models/tna/tna-counters/tna-counter-dto";
import { TnACountersFilter } from "../../models/tna/tna-counters/tna-counters-filter";
import { TnAAffectedDateSTO } from "../../models/tna/tna-data/tna-affected-date-sto";
import { TnALocationDTO } from "../../models/tna/tna-location/tna-location-dto";
import { TnALocationSTO } from "../../models/tna/tna-location/tna-location-sto";
import { PropsFilter } from "../../models/api/props-filter";
import { TnALocationTypeDTO } from "../../models/tna/tna-location-type/tna-location-type-dto";
import { TnALocationTypeSTO } from "../../models/tna/tna-location-type/tna-location-type-sto";
import { TnAMobileHoursBalanceDTO } from "../../models/tna/tna-mobile-hours/tna-mobile-hours-balance-dto";
import { STOModel } from "../../models/base/sto-model";
import { TnAMobileHoursBalanceFilter } from "../../models/tna/tna-mobile-hours/tna-mobile-hours-balance-filter";
import { TnADueVsWorkedCorrectionDTO } from "../../models/tna/tna-due-vs-worked-correction/tna-due-vs-worked-correction-dto";
import { TnADueVsWorkedCorrectionSTO } from "../../models/tna/tna-due-vs-worked-correction/tna-due-vs-worked-correction-sto";

export class TnAEmployeeDataApiService extends BaseApiService<TnADataDTO, TnAAffectedDateSTO> {
  constructor() {
    super({
      servicePath: "/TnAData",
      loadItemsPath: "/GetTnAEmployeeData",
      saveItemsPath: "",
    });
  }
}

export const loadTnaData = async (propsFilter: TnADataFilter, forManager: boolean, signal: AbortSignal | undefined) => {
  const apiService = new TnAEmployeeDataApiService();
  if (forManager) {
    apiService.useLoadItemsPath("/GetTnAEmployeesData");
  }
  const response = await apiService.loadItems(
    propsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export class TnACountersApiService extends BaseApiService<TnACounterDTO, TnAClockingSTO> {
  constructor() {
    super({
      servicePath: "/TnAData",
      loadItemsPath: "/GetTnAEmployeeCounters",
      saveItemsPath: "",
    });
  }
}

export const loadTnACounters = async (
  propsFilter: TnACountersFilter,
  forManager: boolean,
  signal: AbortSignal | undefined
) => {
  const apiService = new TnACountersApiService();
  if (forManager) {
    apiService.useLoadItemsPath("/GetTnAEmployeesCounters");
  }
  const response = await apiService.loadItems(
    propsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export class TnALocationApiService extends BaseApiService<TnALocationDTO, TnALocationSTO> {
  constructor() {
    super({
      servicePath: "/TnALocation",
      loadItemsPath: "/GetTnALocation",
      saveItemsPath: "/SaveTnALocation",
    });
  }
}

export const loadTnALocations = async (propsFilter: PropsFilter, signal: AbortSignal | undefined) => {
  const apiService = new TnALocationApiService();
  const response = await apiService.loadItems(
    propsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export class TnALocationTypesApiService extends BaseApiService<TnALocationTypeDTO, TnALocationTypeSTO> {
  constructor() {
    super({
      servicePath: "/TnALocationType",
      loadItemsPath: "/GetTnALocationType",
      saveItemsPath: "/SaveTnALocationType",
    });
  }
}

export class TnAMobileHoursApiService extends BaseApiService<TnAMobileHoursBalanceDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/TnAData",
      loadItemsPath: "/GetTnAMobileHoursBalance",
      saveItemsPath: "",
    });
  }
}

export const loadTnAMobileHours = async (propsFilter: TnAMobileHoursBalanceFilter, signal: AbortSignal | undefined) => {
  const apiService = new TnAMobileHoursApiService();
  const response = await apiService.loadItems(
    propsFilter,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  toastifyResponse(response, "failed");

  return response;
};

export class TnAWorkedHoursCorrectionApiService extends BaseApiService<
  TnADueVsWorkedCorrectionDTO,
  TnADueVsWorkedCorrectionSTO
> {
  constructor() {
    super({
      servicePath: "/DueVSWorkedCorrection",
      loadItemsPath: "/GetTnAExtraHours",
      saveItemsPath: "/SaveTnAExtraHours",
    });
  }
}
